import { lazy } from "react";
import type { IntakeBoardViewProps } from "./IntakeBoard";
import { setStudioView } from "../workspace/studio-views";
const IntakeBoardView = lazy(() => import("./IntakeBoard").then(module => ({ default: module.IntakeBoardView })));
/** The decision board beside the conversation (#100); one view, re-rendered whenever the intake state changes. */
export function mountIntakeBoard(_host: Element, props: IntakeBoardViewProps) {
  setStudioView("intake-board", "intake-board", <IntakeBoardView {...props} />);
}
